var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button-scroll-up btn btn--primary',
        {'button-scroll-up--displayed': _vm.btnDisplayed},
        {'button-scroll-up--visible': _vm.btnVisible}
    ],attrs:{"type":"button","title":"К началу"},on:{"click":_vm.scrollUp}},[_c('svg',{staticClass:"button-scroll-up__icon",attrs:{"width":"14","height":"6"}},[_c('use',{attrs:{"xlink:href":"#icon-arrow"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }